export const uuidRegex = /^[0-9a-f]{32}$/;

export function isUuid(uuid: string): uuid is string {
	return uuidRegex.test(uuid);
}
